import type { AskRedoUIMessage } from "../types";

type ToolPartSettlement =
  | { state: "output-available"; output: unknown }
  | { state: "output-error"; errorText: string };

export function settlePendingToolPart(
  messages: AskRedoUIMessage[],
  toolCallId: string,
  settlement: ToolPartSettlement,
): AskRedoUIMessage[] {
  return messages.map((message) => {
    if (message.role !== "assistant") {
      return message;
    }
    let changed = false;
    const parts = message.parts.map((part) => {
      if (
        part.type !== "dynamic-tool" ||
        part.toolCallId !== toolCallId ||
        part.state === "output-available" ||
        part.state === "output-error" ||
        part.state === "output-denied"
      ) {
        return part;
      }
      changed = true;
      return {
        type: "dynamic-tool" as const,
        toolName: part.toolName,
        toolCallId: part.toolCallId,
        input: part.input,
        ...settlement,
      };
    });
    return changed ? { ...message, parts } : message;
  });
}
